import { r } from './useApi';
import { keeper } from './utils';
import { normalizeBySchema } from './useDataModels';

export const listUsers = async (filter = {}) => {
    const res = await r({
        endpoint: `${keeper('apiUrl')}/v2/user`,
        sessionToken: keeper('sessionToken'),
        method: 'get',
        data: filter,
    });
    return res;
};

export const getUser = async (userId) => {
    let res = {},
        searchEndpoint = '/v2/user';

    if (userId !== '0') {
        res =
            (await r({
                endpoint: `${keeper('apiUrl')}/v2/user/${userId}`,
                sessionToken: keeper('sessionToken'),
                method: 'get',
            })) || {};
    }

    if (Object.keys(res).length === 0) {
        res = await normalizeBySchema(searchEndpoint, 'post', res);
    }

    if (!res.role || typeof res.role !== 'string') {
        res.role = 'NONE';
    }
    if (!res.id || typeof res.id !== 'string') {
        res.id = '0';
    }
    return res;
};

export const saveUser = async (userId, data, saving = {}) => {
    let method = 'put',
        endpoint = `${keeper('apiUrl')}/v2/user/${userId}`,
        searchEndpoint = '/v1/user/{userId}',
        defaultTypeName = 'UpdateUserRequest';

    if (userId === '0') {
        method = 'post';
        searchEndpoint = '/v1/user';
        endpoint = `${keeper('apiUrl')}/v1/user`;
        // THIS WILL LIKELY CHNAGE defaultTypeName = 'UpdateUserRequest';
    }

    const dataModel = await normalizeBySchema(searchEndpoint, method, data);
    dataModel.typeName =
        !dataModel.typeName || dataModel.typeName.length === 0
            ? defaultTypeName
            : dataModel.typeName;

    if (!('password' in data) || data.password.length === 0) {
        delete dataModel.password;
    }

    const res = await r({
        endpoint: endpoint,
        sessionToken: keeper('sessionToken'),
        method: method,
        data: dataModel,
    });
    saving.active = false;
    return res;
};

export const patchUser = async (userId, data = {}, saving = {}) => {
    const method = 'patch',
        searchEndpoint = '/v2/user/{userId}',
        endpoint = `${keeper('apiUrl')}/v2/user/${userId}`,
        defaultTypeName = 'PatchUserRequest';

    const dataModel = await normalizeBySchema(searchEndpoint, method, data);
    dataModel.typeName =
        !dataModel.typeName || dataModel.typeName.length === 0
            ? defaultTypeName
            : dataModel.typeName;

    const res = await r({
        endpoint: endpoint,
        sessionToken: keeper('sessionToken'),
        method: method,
        data: dataModel,
    });
    console.log('useUsers.js: patch', res);
    saving.active = false;
    return res;
};

export const useUsers = () => {
    return {
        listUsers: listUsers,
        getUser: getUser,
        patchUser: patchUser,
        saveUser: saveUser,
    };
};

export default useUsers;
